import { useIntl } from 'react-intl';
import { useState } from 'react';
import { ListBox, MenuTrigger, Popover, type Key } from 'react-aria-components';
import { FilterButton, Option } from '@repo/design-system-kit';
import { useSegment } from '@repo/poly-hooks/segment';
import { IconPlusOutlined } from '@repo/monochrome-icons';
import styles from './add-filter-button.module.css';

const ADD_FILTERS_TRACKING_EVENT = 'add_filters_clicked';

interface AddFilterButtonProps {
  options: { label: string; value: string }[];
  onSelect: (key: Key | undefined) => void;
}

export function AddFilterButton({ options, onSelect }: AddFilterButtonProps) {
  const { formatMessage } = useIntl();
  const segment = useSegment();
  const [open, setOpen] = useState(false);

  return (
    <MenuTrigger
      isOpen={open}
      onOpenChange={isOpen => {
        if (isOpen) {
          segment.track(ADD_FILTERS_TRACKING_EVENT);
        }
        setOpen(isOpen);
      }}
    >
      <FilterButton className={styles.addFilterButton}>
        <IconPlusOutlined />
        {formatMessage({ id: 'shared-kit.filters.add-filter' })}
      </FilterButton>
      <Popover className={styles.popover}>
        <ListBox
          className={styles.optionList}
          onSelectionChange={keys => {
            onSelect(Array.from(keys)[0]);
            setOpen(false);
          }}
          selectionMode="single"
        >
          {options.map(option => (
            <Option id={option.value} key={option.value}>
              {option.label}
            </Option>
          ))}
        </ListBox>
      </Popover>
    </MenuTrigger>
  );
}
